import { Link, useLocation } from 'react-router'

import { ArticleIcon } from '@pleio/icons/article'

import { CoverImage } from 'js/components/CoverImage'
import TiptapView from 'js/components/Tiptap/TiptapView'
import { FeaturedViewFieldsFragment } from 'js/lib/fragments/FeaturedViewFields.fragment.generated'
import styles from 'js/magazine-issue/View/components/TableOfContents/TableOfContentsItem/TableOfContentsItem.module.css'

type TableOfContentsItemProps = {
    url: string
    title: string
    abstract?: string
    icon?: React.ReactNode
    featured?: FeaturedViewFieldsFragment
    direction: 'back' | 'forward'
}

const TableOfContentsItem = ({
    url,
    title,
    abstract,
    icon,
    featured,
    direction,
}: TableOfContentsItemProps) => {
    const location = useLocation()

    return (
        <Link
            className={styles.wrapper}
            to={url}
            state={{
                prevPathname: location.state?.prevPathname,
                direction,
            }}
        >
            {featured?.image || featured?.video ? (
                <CoverImage
                    featured={featured}
                    hideCaption
                    size="cover"
                    videoButtonSize="small"
                    className={styles.tocItemFeatured}
                />
            ) : (
                <div className={styles.tocItemIcon}>
                    {icon || <ArticleIcon />}
                </div>
            )}

            <div className={styles.tocItemText}>
                <h2 className={styles.tocItemTitle}>{title}</h2>
                {abstract && <TiptapView content={abstract} textSize="small" />}
            </div>
        </Link>
    )
}

export default TableOfContentsItem
